<template>
  <div>
    <form novalidate @submit.prevent>
      <div class="form-group">
        <textarea
          id="comments"
          v-model.trim="comment"
          v-focus
          class="form-control"
          cols="5"
          rows="10"
          minlength="10"
          maxlength="200"
          placeholder="Enter you query here."
        >
        </textarea>
        <div v-if="$v.comment.$invalid && $v.comment.$dirty" class="text-danger input-error">
          Enter atleast 10 characters
        </div>
      </div>
      <div class="form-group">
        <BotControlAOB
          :display-data="showRecaptcha"
          @closeModal="showRecaptcha = false"
          @recaptchaResponseData="submitQuery"
        />
      </div>
      <div class="action-btns">
        <input
          id="submitQuery"
          type="submit"
          value="Submit Query"
          class="btn btn-sm btn-primary"
          @click="displayCaptcha"
        />
        <input type="button" value="Close" class="btn btn-sm btn-default" @click="back" />
      </div>
    </form>
    <modal v-model="successModal" effect="fade" width="30%">
      <div slot="modal-header" class="modal-header"><strong class="modal-title"></strong></div>
      <p>
        Your request has been submitted successfully.
        <span class="fa fa-check-circle text-success fa-lg" />
      </p>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-sm btn-primary" @click="resetPage">OK</button>
      </div>
    </modal>

    <!-- notification failure -->
    <modal v-model="registrationFailed" effect="fade" width="40%">
      <div slot="modal-header" class="modal-header"><strong class="modal-title">Message</strong></div>
      <div>
        <span class="fa fa-exclamation text-warning fa-lg" />
        Your request could not be submitted due to an intermittent connection issue! Please try submitting your request
        again after sometime.
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button id="forgotUser" type="button" class="btn btn-sm btn-primary" @click="regFailed()">
          OK
        </button>
      </div>
    </modal>

    <spinner
      v-model="spinner.show"
      :global="spinner.isGlobal"
      :size="spinner.size"
      :fixed="spinner.fixed"
      :text="spinner.spinnerText"
    />
  </div>
</template>

<script>
import modal from "build-ui-x/src/Modal";
import { submitQuery } from "@/services/endpointsService";
import spinner from "build-ui-x/src/Spinner";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import BotControlAOB from "@/mycfm/components/new-company/BotControlAOB";

export default {
  components: {
    spinner,
    modal,
    BotControlAOB
  },
  data() {
    return {
      spinner: {
        fixed: false,
        isGlobal: false,
        show: false,
        size: "md",
        spinnerText: ""
      },
      comment: "",
      successModal: false,
      showRecaptcha: false,
      registrationFailed: false
    };
  },
  validations: {
    comment: {
      required,
      minLength: minLength(10)
    }
  },
  computed: {
    ...mapState("user", ["user"])
  },
  methods: {
    regFailed() {
      this.registrationFailed = false;
      window.location.reload();
    },
    displayCaptcha() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.showRecaptcha = true;
      if (window.grecaptcha) {
        window.grecaptcha.reset();
      }
    },
    submitQuery(recaptchaValue) {
      this.spinner.show = true;
      let config = {
        params: {
          comment: this.comment
        },
        headers: {
          "g-recaptcha-response": recaptchaValue
        }
      };
      submitQuery(this.user.email, config)
        .then(data => {
          if (data.caseCreated) {
            this.successModal = true;
          }
        })
        .catch(() => {
          this.registrationFailed = true;
        })
        .finally(() => {
          // hide spinner
          this.spinner.show = false;
        });
    },
    resetPage() {
      this.$emit("close-inquiry");
    },
    back() {
      this.$emit("close-inquiry");
    }
  }
};
</script>

<style lang="less" scoped>
#comments {
  width: 300px;
  height: 80px;
}
</style>
